import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXMG6TQSxTx-iIaXHxmtRnl0w4g85kXUo",
  authDomain: "cashvax.firebaseapp.com",
  projectId: "cashvax",
  storageBucket: "cashvax.firebasestorage.app",
  messagingSenderId: "1011528372477",
  appId: "1:1011528372477:web:3b8ead8bae6cf756742e94",
  measurementId: "G-GWE2CTXB0Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

export { app, auth, db, functions, storage };
